import { t } from "../../i18n";
import type {
  Draft,
  Field,
} from "../../pages/integrations/IntegrationsPage.utils";

export function FieldInput({
  field,
  draft,
  editing,
  setConfig,
}: {
  field: Field;
  draft: Draft;
  editing: boolean;
  setConfig: (key: string, value: string | boolean) => void;
}) {
  const value = String(draft.config[field.key] ?? "");
  const requirementLabel = field.required
    ? editing
      ? "Saved"
      : "Required"
    : "Optional";
  return (
    <label>
      <span className="mb-1.5 flex flex-wrap items-center gap-2 text-sm font-semibold text-stone-700 dark:text-stone-200">
        <span>{field.label}</span>
        <span
          className={`rounded-full px-2 py-0.5 text-[10px] font-bold tracking-wide uppercase ${requirementLabel === "Required" ? "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300" : requirementLabel === "Saved" ? "bg-stone-100 text-stone-500 dark:bg-white/10 dark:text-stone-400" : "bg-stone-100 text-stone-500 dark:bg-white/10 dark:text-stone-400"}`}
        >
          {requirementLabel}
        </span>
        {field.defaultValue && !editing && (
          <span className="rounded-full bg-lumen-50 px-2 py-0.5 text-[10px] font-bold tracking-wide text-lumen-700 uppercase dark:bg-lumen-950/50 dark:text-lumen-300">
            {t("Auto-filled")}
          </span>
        )}
      </span>
      {field.multiline ? (
        <textarea
          className="field min-h-28 font-mono text-xs"
          required={!editing && field.required}
          value={value}
          placeholder={
            editing ? "Leave blank to keep current" : field.placeholder
          }
          onChange={(event) => setConfig(field.key, event.target.value)}
        />
      ) : (
        <input
          className="field"
          type={field.type ?? (field.secret ? "password" : "text")}
          required={!editing && field.required}
          value={value}
          placeholder={
            editing ? "Leave blank to keep current" : field.placeholder
          }
          onChange={(event) => setConfig(field.key, event.target.value)}
        />
      )}
      <span className="mt-1 block text-xs leading-5 text-stone-500">
        {field.description}
        {editing && field.secret
          ? " Your existing value stays unchanged if you leave this blank."
          : ""}
      </span>
    </label>
  );
}
